import React from "react";
import { waLink } from "../lib/execora";

export const StickyWhatsApp = () => {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-whatsapp-cta"
      aria-label="Order on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#84cc15] opacity-60 pulse-ring" aria-hidden="true" />
      <span className="relative flex items-center gap-2 pl-3 pr-4 sm:pl-4 sm:pr-5 h-14 rounded-full bg-[#84cc15] hover:bg-[#65a30d] text-white shadow-[0_10px_30px_-5px_rgba(132,204,21,0.6)] transition-all">
        <span className="h-9 w-9 rounded-full bg-white/20 flex items-center justify-center">
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
            <path d="M19.11 17.24c-.28-.14-1.66-.82-1.92-.92-.26-.1-.45-.14-.64.14s-.73.92-.9 1.11c-.17.19-.33.21-.61.07-.28-.14-1.19-.44-2.27-1.41-.84-.75-1.4-1.67-1.57-1.95-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.5.14-.17.19-.28.28-.47.1-.19.05-.36-.02-.5-.07-.14-.64-1.54-.87-2.1-.23-.55-.46-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.28-1 .98-1 2.39 0 1.41 1.02 2.78 1.17 2.98.14.19 2.02 3.08 4.9 4.32.68.29 1.22.47 1.64.6.69.22 1.31.19 1.8.12.55-.08 1.66-.68 1.9-1.34.24-.66.24-1.22.17-1.34-.07-.12-.26-.19-.54-.33zM12.05 2C6.5 2 2 6.5 2 12.03c0 1.9.5 3.76 1.46 5.4L2 22l4.71-1.43A9.98 9.98 0 0 0 12.05 22C17.6 22 22.1 17.5 22.1 11.97 22.1 6.44 17.6 2 12.05 2z" />
          </svg>
        </span>
        <span className="hidden sm:inline text-sm font-semibold pr-1">Order on WhatsApp</span>
      </span>
    </a>
  );
};

export default StickyWhatsApp;
